import Immutable from 'immutable';
import { scoreForSport } from '@/common/score';

export const periodScores = event =>
    Immutable.fromJS(
        scoreForSport(
            event.get('periodScores') ? event.get('periodScores').toJS() : null,
            event.get('sportId'),
            event.get('basketballMatchType')
        )
    );

export const activePeriod = event => {
    const activeCode = event.getIn(['currentPeriod', 'code']);
    const scores = periodScores(event);
    if (activeCode && scores) {
        const found = scores.findKey(ps => ps.getIn(['period', 'code']) === activeCode);
        return found > -1 ? found : scores.size - 1;
    }
    return null;
};
